import { type Region } from '@/navbar/navbar.types'

export const ECOID_DOMAINS: Record<Region, string> = {
  test:    'https://auth.test.ecoonline.net',
  staging: 'https://auth.stage.ecoonline.net',
  eu:      'https://auth.ecoonline.net',
  us:      'https://auth.us.ecoonline.com',
  ca:      'https://auth.ca.ecoonline.com',
  uk:      'https://auth.uk.ecoonline.com',
  au:      'https://auth.au.ecoonline.com',
}
